import http from "../AppConfig";
import {Encrypt} from "@/plugins/cryptojs";
import { getGroupName } from "../util/SystemUtil";

const c = encodeURIComponent(Encrypt(getGroupName()));

class CommonSettingsService {
  getCommonSetting(hash) {
    return http.get(`common-settings?hash=${hash}&c=${c}`);
  }

  saveCommonSetting(commonSettings, hash, token) {
    return http.post(`common-settings?hash=${hash}&c=${c}`, commonSettings, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  getAccessAnalysisSettings(hash) {
    return http.get(`access-analysis-settings?hash=${hash}&c=${c}`);
  }
}

export default new CommonSettingsService();
